<template>
  <full-container>
    <!--工具条-->
    <div slot="header" class="toolbar">
      <el-form :inline="true" :model="queryParams" size="small" class="search-form">
        <el-form-item>
          <el-input v-model="queryParams.keyWord" placeholder="名称关键字" clearable>
            <el-button slot="append" icon="el-icon-search" @click="onSearch()" />
          </el-input>
        </el-form-item>
      </el-form>
      <router-link v-action="'/api/Message/Submit'" class="el-button el-button--primary el-button--small" type="primary" icon="el-icon-plus" :to="{ path: 'form' }">发送消息</router-link>
    </div>

    <!--表格-->
    <el-table v-loading="loading" ref="tb" :data="datalist.Items" height="100%">
      <el-table-column width="50" align="center">
        <template slot-scope="{ row }">
          <i :class="row.State ? 'el-icon-bell' : 'el-icon-close-notification'" :title="row.State ? '已发送' : '未发送'" />
        </template>
      </el-table-column>
      <el-table-column prop="Sender" label="发送人" min-width="100" show-overflow-tooltip />
      <el-table-column label="消息内容" min-width="300" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <el-tag size="mini">{{ $utils.meta.format('message', row.Type) }}</el-tag>
          <label class="text-info text-sm" style="margin-left: 5px">{{ row.Message }}</label>
        </template>
      </el-table-column>
      <el-table-column prop="Publish" label="日期" min-width="100" />
      <el-table-column label="状态/操作" width="100">
        <template slot-scope="{ row }">
          <el-link type="primary" @click="$router.push({ path: `detail/${row.Id}` })">查看</el-link>
          <el-link type="primary" @click="$router.push({ path: `form/${row.Id}` })">修改</el-link>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div slot="footer" class="toolbar">
      <el-pagination background :page-size="queryParams.size" :total="datalist.TotalCount" @current-change="onSearch" />
    </div>
  </full-container>
</template>



<script>
export default {
  data () {
    return {
      loading: false,
      datalist: [],
      queryParams: {
        index: 1,
        size: 20,
      },
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    // 查询参数
    onSearch (val = 1) {
      this.queryParams.index = val
      this.loadData()
    },
    // 信息列表
    loadData () {
      this.loading = true
      this.$apis.system.message.getSends(this.queryParams).then((res) => {
        this.datalist = res
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
